import { useState, useEffect } from "react";
import "./invoiceCreate.css";
import { MdDelete } from "react-icons/md";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useUserAuth } from "../../context/UserAuthContext";
import axios from "axios";
import { toast } from "react-toastify";

const InvoiceCreate = () => {
  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
  const { user, language, token } = useUserAuth();
  const user_id = user.uid;
  const [items, setItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [text, setText] = useState("");
  const [terms, setTerms] = useState([
    {
      id: 1,
      term: "All amounts are in INR. Please make payments in the specified currency.",
      user_id: "na",
    },
    {
      id: 2,
      term: "We accept payments via UPI, Cash, Net Banking, Debit card.",
      user_id: "na",
    },
    {
      id: 3,
      term: "Interest @18% per annum will be charged if not paid within 30 days",
      user_id: "na",
    },
    {
      id: 4,
      term: "All disputes subject to lucknow jurisdiction.",
      user_id: "na",
    },
    {
      id: 5,
      term: "Goods & Services will not be taken back.",
      user_id: "na",
    },
    {
      id: 7,
      term: "A 50% upfront payment is required to begin working on.",
      user_id: "na",
    },
  ]);
  const [termShow, setTermShow] = useState(false);
  useEffect(() => {
    if (!user_id) return;
    const getInvoiceItems = async () => {
      try {
        const res = await axios.get(
          `${base_url}/api/v1/invoice-items/${user_id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        console.log("this is items", res.data.data);
        setItems(res.data.data);
      } catch (err) {
        console.log("getting terms error", err);
      }
    };
    getInvoiceItems();
    const getInvoiceTerms = async () => {
      try {
        const res = await axios.get(
          `${base_url}/api/v1/invoice-terms/${user_id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        // console.log("this is terms", res.data.data);
        setTerms(res.data.data);
      } catch (err) {
        console.log("getting terms error", err);
      }
    };
    getInvoiceTerms();
  }, [user_id, token]);

  useEffect(() => {
    const filteredItems = items?.filter((item) =>
      item.title.toLowerCase().includes(text.toLowerCase())
    );
    setFilteredItems(filteredItems);
  }, [items, text]);
  const [documentId, setDocumentId] = useState(0);
  useEffect(() => {
    if (!user_id) return;
    const getTotalInvoice = async () => {
      try {
        const res = await axios.get(
          `${base_url}/api/v1/invoice/user/${user_id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        // console.log("this is invoice", res.data.data);
        setDocumentId(res.data.data);
      } catch (err) {
        console.log("getting terms error", err);
      }
    };
    getTotalInvoice();
  }, [user_id, token]);

  const searchHandler = (e) => {
    setText(e.target.value);
  };

  const [billItem, setBillItem] = useState([]);
  const addItemToBill = (item) => {
    const itemExists = billItem.some(
      (existingItem) => existingItem.id === item.id
    );
    if (!itemExists) {
      setBillItem([...billItem, item]);
      setText("");
    } else {
      alert("Item already exists in the bill.");
    }
  };
  const removeBillItem = (index) => {
    const updatedItem = billItem.filter((item, curIndex) => curIndex !== index);
    setBillItem(updatedItem);
  };

  const [data, setData] = useState({
    customerName: "",
    billToAddress: "",
    shipToAddress: "",
    deliveryDate: "",
    customerGst: "",
    customerMobNo: "",
    venueName: "",
  });
  const formHandler = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setData({ ...data, [name]: value });
  };
  const totalAmount = billItem.reduce(
    (acc, item) => acc + Number(item.qty * item.price),
    0
  );

  const [invoiceMode, setInvoiceMode] = useState(null);
  const [gst, setGst] = useState(0);
  const [cgst, setCgst] = useState(0);
  const [sgst, setSgst] = useState(0);

  const gstSelector = (status) => {
    setInvoiceMode(status);
    if (!status) {
      setGst(0);
      setCgst(0);
      setSgst(0);
    }
  };
  const invoiceCalculator = () => {
    if (gst.length > 0) {
      const divide = (gst / 2).toFixed(1);
      setCgst(divide);
      setSgst(divide);
    }
  };

  const [termInvoice, setTermInvoice] = useState([]);

  const invoiceTermHandler = (index) => {
    setTermInvoice([...termInvoice, terms[index]]);
    const updateTerm = terms.filter((preData, indexx) => index !== indexx);
    setTerms(updateTerm);
  };

  const removeSelectedInvoiceTerm = (curIndex) => {
    const totalSelectedTerm = [...termInvoice];
    const updatedTerm = totalSelectedTerm.filter(
      (cur, index) => index !== curIndex
    );
    setTermInvoice(updatedTerm);
  };

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [item, setItem] = useState({
    term_title: "",
    term_description: "",
    term_price: "",
  });
  const modelHandler = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setItem({ ...item, [name]: value });
  };
  const btnHandler = async (e) => {
    e.preventDefault();
    const {
      term_title: title,
      term_description: description,
      term_price: price,
    } = item;
    if (title !== "" && description !== "" && price !== "") {
      try {
        const res = await axios.post(
          `${base_url}/api/v1/invoice-items`,
          {
            title,
            description,
            price,
            qty: 1,
            user_id,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        console.log("API Response:", res.data);

        const newItem = res?.data?.data;

        setItems((prevInvoiceItems) => [...prevInvoiceItems, newItem]);

        setItem({
          term_title: "",
          term_description: "",
          term_price: "",
        });

        handleClose();
        alert("Item added successfully");
      } catch (err) {
        console.log("API Error:", err);
        alert("Something went wrong!");
      }
    } else {
      alert("All field Required");
    }
  };
  const qtyHandler = (e, index) => {
    const qty = e.target.value;
    const updatedBillItem = [...billItem];
    updatedBillItem[index].qty = qty;
    setBillItem(updatedBillItem);
  };
  const priceHandler = (e, index) => {
    const price = e.target.value;
    const updatedBillItem = [...billItem];
    updatedBillItem[index].price = price;
    setBillItem(updatedBillItem);
  };

  const [discountType, setDiscountType] = useState("");
  const [discount, setDiscount] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  useEffect(() => {
    if (!discountType) return;
    let res = 0;
    if (discountType == "percent") {
      res = Number((totalAmount * discount) / 100).toFixed(2);
    } else {
      res = Number(discount).toFixed(2);
    }
    setTotalDiscount(res);
  }, [discount, discountType, billItem]);

  const [advanceData, setAdvanceData] = useState({
    amount: "",
    date: "",
    paymentMode: "",
  });

  const advanceDataHandler = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setAdvanceData({ ...advanceData, [name]: value });
  };
  const subTotal = Number(totalAmount - totalDiscount).toFixed(2);
  let cgstAmount = ((subTotal * cgst) / 100).toFixed(2);
  let sgstAmount = ((subTotal * sgst) / 100).toFixed(2);
  const grandTotal = (
    Number(subTotal) +
    Number(cgstAmount) +
    Number(sgstAmount)
  ).toFixed(2);
  const dueAmount = (grandTotal - Number(advanceData.amount)).toFixed(2);

  const generateInvoiceHandler = async () => {
    const {
      customerName,
      billToAddress,
      shipToAddress,
      deliveryDate,
      customerMobNo,
      customerGst,
      venueName,
    } = data;

    const { amount, date, paymentMode } = advanceData;

    if (
      customerName !== "" &&
      billToAddress !== "" &&
      shipToAddress !== "" &&
      deliveryDate !== "" &&
      customerMobNo !== "" &&
      venueName !== ""
    ) {
      if (billItem.length > 0) {
        const payload = {
          user_id,
          advance: {
            paymentMode,
            date,
            amount,
          },
          customerInfo: {
            customerName,
            billToAddress,
            shipToAddress,
            deliveryDate,
            customerMobNo,
            venueName,
            customerGst: customerGst || "",
          },
          discount: {
            discountType,
            discount,
            totalDiscount,
          },
          gst: {
            invoiceMode,
            cgst,
            sgst,
            cgstAmount,
            sgstAmount,
          },
          termInvoice,
          totalAmount,
          grandTotal,
          dueAmount,
          billItem,
        };

        try {
          const response = await axios.post(
            `${base_url}/api/v1/invoice`,
            payload,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          // console.log(response.data.statusCode);
          if (response.data.statusCode === 201) {
            toast.success("Invoice generated successfully");
            setData({
              customerName: "",
              billToAddress: "",
              shipToAddress: "",
              deliveryDate: "",
              customerGst: "",
              customerMobNo: "",
              venueName: "",
            });
            setAdvanceData({
              amount: "",
              date: "",
              paymentMode: "",
            });
            setDiscountType("");
            setDiscount(0);
            setTotalDiscount(0);
            setInvoiceMode(false);
            setGst(0);
            setCgst(0);
            setSgst(0);
            setBillItem([]);
            setTermInvoice([]);
            setTermShow(false);
          } else {
            alert("Failed to generate invoice");
          }
        } catch (error) {
          console.error("Error generating invoice:", error);
          alert("An error occurred while generating the invoice");
        }
      } else {
        alert("Please add at least 1 product to generate invoice");
      }
    } else {
      alert("Customer Info is required");
    }
  };
  const idsInArray1 = termInvoice.map((item) => item.id);
  return (
    <div className="page-wrapper">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div
                className="card-header text-white"
                style={{ backgroundColor: "#085f9a" }}
              >
                {language === "en" ? `Create Invoice` : `नया बिल बनाएं`}
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                    <h4 style={{ color: `var(--primary-color)` }}>
                      {language === "en" ? ` Client Details` : `ग्राहक विवरण`}
                    </h4>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="customerName">
                        {language === "en" ? `Customer Name` : `ग्राहक का नाम`}
                      </label>
                      <input
                        type="text"
                        name="customerName"
                        value={data.customerName}
                        onChange={formHandler}
                        placeholder="Enter Customer Name"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="customerName">
                        {language === "en"
                          ? `Customer Address`
                          : `ग्राहक का पता`}
                      </label>
                      <input
                        type="text"
                        name="billToAddress"
                        value={data.billToAddress}
                        onChange={formHandler}
                        placeholder="Enter Customer Address"
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="customerMobNo">
                        {language === "en"
                          ? `Customer Mobile Number`
                          : `ग्राहक मोबाइल नंबर`}
                      </label>
                      <input
                        type="tel"
                        maxLength={10}
                        id="customerMobNo"
                        name="customerMobNo"
                        value={data.customerMobNo}
                        onChange={formHandler}
                        className="form-control"
                        placeholder="Mobile Number"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="customerGst">
                        {language === "en"
                          ? ` Customer GST (Optional) `
                          : ` ग्राहक का जीएसटी नंबर (ऑप्शनल)`}
                      </label>
                      <input
                        type="text"
                        min={15}
                        max={15}
                        maxLength={15}
                        id="customerGst"
                        name="customerGst"
                        value={data.customerGst}
                        onChange={formHandler}
                        className="form-control"
                        placeholder="Customer GST"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <h4 style={{ color: `var(--primary-color)` }}>
                        {language === "en" ? `Venue Details` : `वेन्यू विवरण`}
                      </h4>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="customerGst">
                        {language === "en" ? `Venue Name ` : `वेन्यू का नाम`}
                      </label>
                      <input
                        type="text"
                        name="venueName"
                        value={data.venueName}
                        onChange={formHandler}
                        placeholder="Venue Name"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="customerGst">
                        {language === "en" ? `Venue Address` : `वेन्यू पता`}
                      </label>
                      <input
                        type="text"
                        name="shipToAddress"
                        value={data.shipToAddress}
                        onChange={formHandler}
                        placeholder="Venue Address"
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label htmlFor="deliveryDate">
                        {language === "en"
                          ? `Delivery / Event Date`
                          : `इवेंट तिथि`}
                      </label>
                      <input
                        type="date"
                        id="deliveryDate"
                        name="deliveryDate"
                        value={data.deliveryDate}
                        onChange={formHandler}
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
                <label htmlFor="">
                  {" "}
                  {language === "en"
                    ? `Search Product`
                    : `अपना प्रोडक्ट/सर्विसेज सर्च करें`}
                </label>
                <input
                  type="text"
                  name="title"
                  className="form-control"
                  placeholder="Search Product"
                  value={text}
                  onChange={searchHandler}
                  autoComplete="false"
                />
                <ul
                  className="mt-3"
                  style={{ listStyle: "none", margin: "0", padding: "0" }}
                >
                  {text && (
                    <>
                      {filteredItems?.map((item, index) => {
                        return (
                          <li
                            key={index}
                            className="searchList"
                            onClick={() => addItemToBill(item)}
                          >
                            {item.title}
                          </li>
                        );
                      })}
                      {filteredItems?.length < 1 && (
                        <>
                          <p className="text-warning">
                            {language === "en"
                              ? `No Item Found`
                              : `कोई वस्तु नहीं मिली`}
                          </p>
                          <button
                            className="btn my-bg mb-3"
                            onClick={handleShow}
                          >
                            +{language === "en" ? `Add Item` : `वस्तु जोड़ें`}
                          </button>
                        </>
                      )}
                    </>
                  )}
                </ul>
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th className="w-10">
                          {language === "en" ? `S.No.` : `क्रमांक`}
                        </th>
                        <th>
                          {language === "en" ? `Item/Service` : `वस्तु सेवाएं`}
                        </th>
                        <th>{language === "en" ? `Description` : `विवरण`}</th>
                        <th>{language === "en" ? `Qty` : `मात्रा`}</th>
                        <th>
                          {language === "en" ? `Unit Price` : `यूनिट मूल्य`}
                        </th>
                        <th>{language === "en" ? `Price` : `मूल्य`}</th>
                        <th>{language === "en" ? `Remove` : `डिलीट करें`}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {billItem.map((item, index) => {
                        const { title, description, qty, price } = item;
                        return (
                          <tr key={index}>
                            <td className="w-10">{index + 1}</td>
                            <td>{title}</td>
                            <td>{description}</td>
                            <td>
                              <input
                                type="number"
                                value={qty}
                                onChange={(e) => qtyHandler(e, index)}
                                min={1}
                                style={{ width: "100px" }}
                              />
                            </td>
                            <td>
                              &#8377; &nbsp;
                              <input
                                type="number"
                                value={price}
                                onChange={(e) => priceHandler(e, index)}
                                min={1}
                                style={{ width: "100px" }}
                              />
                            </td>
                            <td>&#8377; {Number(qty * price).toFixed(2)}</td>
                            <td>
                              <MdDelete
                                size={24}
                                color="red"
                                onClick={() => removeBillItem(index)}
                                className="my-cursor"
                              />
                            </td>
                          </tr>
                        );
                      })}
                      <tr>
                        <td colSpan={5}>
                          {language === "en" ? `Sub Total` : `सब टोटल`}
                        </td>
                        <td colSpan={2}>
                          &#8377; {Number(totalAmount).toFixed(2)}{" "}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={3}>
                          <select
                            onChange={(e) => setDiscountType(e.target.value)}
                            className="form-select"
                            defaultValue={""}
                            // onBlur={discountCalculator}
                          >
                            <option disabled value="">
                              {" "}
                              {language === "en"
                                ? `Discount (If Any)`
                                : `डिस्काउंट (अगर कोई है) `}
                            </option>
                            <option value="percent">Percent(%)</option>
                            <option value="amounut">Fix Amount</option>
                          </select>
                        </td>
                        <td colSpan={2}>
                          <input
                            type="number"
                            style={{ width: "100px" }}
                            disabled={!discountType}
                            min={1}
                            max={100}
                            value={discount == 0 ? "" : discount}
                            onChange={(e) => setDiscount(e.target.value)}
                          />
                          &nbsp;{" "}
                          {discountType == "percent" ? "%" : <>&#8377;</>}
                        </td>
                        <td colSpan={2}>{totalDiscount}</td>
                      </tr>
                      {/* <tr>
                                                <td colSpan={7}>Invoice With</td>
                                            </tr> */}
                      <tr>
                        <td colSpan={7}>
                          {" "}
                          <button
                            className="btn text-white mb-2"
                            onClick={() => gstSelector(true)}
                            style={{
                              marginRight: "10px",
                              width: "140px",
                              backgroundColor: `${
                                invoiceMode ? "#156CB3" : "#ccc"
                              }`,
                            }}
                          >
                            {language === "en" ? `GST` : `जीएसटी के साथ`}
                          </button>
                          <button
                            className="btn text-white mb-2"
                            onClick={() => gstSelector(false)}
                            style={{
                              width: "140px",
                              backgroundColor: `${
                                !invoiceMode ? "#156CB3" : "#ccc"
                              }`,
                            }}
                          >
                            {" "}
                            {language === "en" ? `Without GST` : `बिना जीएसटी`}
                          </button>
                        </td>
                        <td></td>
                      </tr>
                      {invoiceMode && (
                        <>
                          <tr>
                            <td colSpan={7}>
                              <div className="col-md-6 col-6">
                                <select
                                  onChange={(e) => setGst(e.target.value)}
                                  className="form-select"
                                  onBlur={invoiceCalculator}
                                  defaultValue={""}
                                >
                                  <option disabled value="">
                                    {" "}
                                    {language === "en"
                                      ? `Select Percentage`
                                      : `चुने`}
                                  </option>
                                  <option value="5">5%</option>
                                  <option value="6">6%</option>
                                  <option value="12">12%</option>
                                  <option value="18">18%</option>
                                  <option value="28">28%</option>
                                </select>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan={5}>CGST {`(${cgst} %)`}</td>
                            <td colSpan={2}>&#8377; {cgstAmount}</td>
                          </tr>
                          <tr>
                            <td colSpan={5}>SGST {`(${sgst} %)`}</td>
                            <td colSpan={2}>&#8377; {sgstAmount}</td>
                          </tr>
                        </>
                      )}
                      <tr>
                        <td colSpan={5}>
                          {language === "en" ? `Total` : `टोटल`}
                        </td>
                        <td colSpan={2}>&#8377; {grandTotal}</td>
                      </tr>
                      <tr>
                        <td colSpan={7}>
                          <h3>
                            {" "}
                            {language === "en"
                              ? `Advance If Any`
                              : `एडवांस अगर कोई है`}
                          </h3>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={2}>
                          <div className="form-group">
                            <label htmlFor="">
                              {" "}
                              {language === "en"
                                ? `Advance Payment`
                                : `प्राप्त एडवांस`}
                            </label>
                            <input
                              type="number"
                              placeholder="Advance Amounut"
                              className="form-control"
                              min={1}
                              name="amount"
                              value={advanceData.amount}
                              onChange={advanceDataHandler}
                            />
                          </div>
                        </td>
                        <td colSpan={2}>
                          <div className="form-group">
                            <label htmlFor="">
                              {language === "en"
                                ? `Payment Date`
                                : `पेमेंट डेट`}
                            </label>
                            <input
                              type="Date"
                              className="form-control"
                              name="date"
                              value={advanceData.date}
                              onChange={advanceDataHandler}
                            />
                          </div>
                        </td>
                        <td colSpan={3}>
                          <div className="form-group">
                            <label htmlFor="">
                              {language === "en"
                                ? `Payment Mode`
                                : `पेमेंट द्वारा`}
                            </label>
                            <select
                              id=""
                              className="form-control"
                              name="paymentMode"
                              onChange={advanceDataHandler}
                              defaultValue={""}
                            >
                              <option disabled value="">
                                Select
                              </option>
                              <option value="UPI">
                                {" "}
                                {language === "en" ? `UPI` : `यूपीआई द्वारा`}
                              </option>
                              <option value="Bank">
                                {" "}
                                {language === "en" ? `Bank` : `बैंक द्वारा`}
                              </option>
                              <option value="Cash">
                                {" "}
                                {language === "en" ? `Cash` : `नगद भुगतान`}
                              </option>
                            </select>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={5}>
                          {language === "en" ? `Due Amount` : `बकाया राशि`}
                        </td>
                        <td colSpan={2}>&#8377; {Number(dueAmount)}</td>
                      </tr>
                      {termInvoice.length > 0 && (
                        <>
                          <tr>
                            <th className="w-10">S.No.</th>
                            <th colSpan={6}>
                              {" "}
                              {language === "en"
                                ? `Terms & Condition`
                                : `नियम और शर्तें`}
                            </th>
                          </tr>
                          {termInvoice.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td className="w-10">{index + 1}</td>
                                <td colSpan={5}>{item.term}</td>
                                <td>
                                  <MdDelete
                                    size={24}
                                    color="red"
                                    className="my-cursor"
                                    onClick={() =>
                                      removeSelectedInvoiceTerm(index)
                                    }
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </>
                      )}
                      <tr>
                        <td colSpan={7}>
                          <button
                            onClick={() => setTermShow(!termShow)}
                            className="btn my-2 my-bg text-white"
                          >
                            {termShow ? "Hide" : "Show"}{" "}
                            {language === "en"
                              ? `Terms & Condition`
                              : `नियम और शर्तें`}
                          </button>
                          {termShow && (
                            <div className="termContainer">
                              {terms?.map((item, index) => {
                                return (
                                  <div
                                    className="termList"
                                    key={index}
                                    onClick={() => invoiceTermHandler(index)}
                                  >
                                    {item.term}
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td colSpan={7}>
                          <button
                            className="btn my-bg text-white"
                            onClick={generateInvoiceHandler}
                          >
                            {language === "en"
                              ? `Generate Invoice`
                              : `इनवॉइस बनाएं`}
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Item</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={btnHandler}>
            <div className="row">
              <div className="form-group">
                <label htmlFor="title">Title</label>
                <input
                  type="text"
                  name="term_title"
                  placeholder="Enter Title"
                  className="form-control"
                  id="title"
                  value={item.term_title}
                  onChange={modelHandler}
                />
              </div>
              <div className="form-group">
                <label htmlFor="description">Description</label>
                <input
                  type="text"
                  name="term_description"
                  placeholder="Enter Description"
                  className="form-control"
                  id="description"
                  value={item.term_description}
                  onChange={modelHandler}
                />
              </div>
              <div className="form-group">
                <label htmlFor="price">Price</label>
                <input
                  type="number"
                  name="term_price"
                  placeholder="Enter Price"
                  className="form-control"
                  id="price"
                  value={item.term_price}
                  onChange={modelHandler}
                />
              </div>
            </div>
            <div className="form-group">
              <input
                type="submit"
                value="Add Item"
                className="btn btn-primary"
              />
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default InvoiceCreate;
